import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserContext } from "../usercontext/UserContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useContext(UserContext);
  const location = useLocation();

  if (loading) {
    return <div>Lade Benutzerstatus...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
